// utils
import PadEditorFurniture from './class/PadEditorFurniture';
// config

const TEMPLATE_NAME = 'PAD_EDITOR_FURNITURE';
//import { PAD_ITEM_TYPE } from 'app/config/pad_item.js';

const initialState = {
  loading: false,
  errors: [],
  data: {
    loaded: [],
    screen: []
  }
};

const reducer = (state = initialState, action) => {
  switch (action.type) {
    case `${TEMPLATE_NAME}_PENDING`: {
      const padEditorFurniture = new PadEditorFurniture(state);

      return padEditorFurniture.setLoading().setErrors().getState();
    }

    case `${TEMPLATE_NAME}_FULFILLED`: {
      const furnitures = action.payload;

      const padEditorFurniture = new PadEditorFurniture(state);

      return padEditorFurniture.prepare(furnitures).setLoading(false).getState();
    }

    case `${TEMPLATE_NAME}_REJECTED`: {
      const errors = action.payload.errors;

      const padEditorFurniture = new PadEditorFurniture(state);

      return padEditorFurniture.setErrors(errors).setLoading(false).getState();
    }

    case `${TEMPLATE_NAME}_ADD`: {
      const furniture = action.payload.data;
      furniture.type = 3;
      const padEditorFurniture = new PadEditorFurniture(state);

      return padEditorFurniture.insert(furniture).getState();
    }

    case `${TEMPLATE_NAME}_EDIT`: {
      const furniture = action.payload.data;
      const { code } = furniture;
      const padEditorFurniture = new PadEditorFurniture(state);

      return padEditorFurniture.update(code, furniture).getState();
    }

    case `${TEMPLATE_NAME}_REMOVE`: {
      const furniture = action.payload.data;
      const { code } = furniture;
      const padEditorFurniture = new PadEditorFurniture(state);

      return padEditorFurniture.remove(code).getState();
    }

    case `${TEMPLATE_NAME}_CHANGE_STATUS`: {
      const furniture = action.payload.data;
      const { code, status: prevStatus } = furniture;
      let status = prevStatus ? 0 : 1;

      const padEditorFurniture = new PadEditorFurniture(state);

      return padEditorFurniture.update(code, { status }).getState();
    }

    case `${TEMPLATE_NAME}_RESET`: {
      return initialState;
    }

    default: {
      return state;
    }
  }
};

export default reducer;
